module.exports = __webpack_public_path__ + "img/lessonattend-finger-green.c88883cc.svg";